<template>
  <div class="comp-status-user" :class="[ computedStatus ]">
    {{ $t(`users.statuses.${computedStatus}`) }}
  </div>
</template>

<script>
  export default {
    name: 'StatusUser',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      values: {
        type: Object,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedStatus() {
        return this.values?.locked ? 'locked' : 'active';
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-status-user {
  display: inline-block;
  color: $color-white-solid-10;
  @include font-body-tiny-semibold;
  text-transform: uppercase;
  padding: 6px 4px;
  border-radius: $default-border-radius;

  &.active {
    background-color: $color-signal-green;
  }
  &.locked {
    background-color: $color-black-alpha-60;
  }
}
</style>
